import FillBlanks from "../../components/ClassOne/EnvironmentScience/MyClothing/FillBlanks";
import MatchClothingItems from "../../components/ClassOne/EnvironmentScience/MyClothing/MatchClothItems";
import OddOneOut from "../../components/ClassOne/EnvironmentScience/MyClothing/OddOneOut";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/MyClothing/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/my-need-clothing/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/class-one/environmental-science/my-need-clothing/true-false", title: "True or False", component: TrueFalse },
    { url: "/class-one/environmental-science/my-need-clothing/match-clothing-items", title: "Match Clothing Items", component: MatchClothingItems },
    { url: "/class-one/environmental-science/my-need-clothing/odd-one-out", title: "Odd One Out", component: OddOneOut }
];

export default topics;